import React from "react";
import Link from "next/link";
import Image from "next/image";

interface CardResourceProps {
  slug: string;
  title: string;
  imageUrl: string;
  imageAlt: string;
}

const CardResource: React.FC<CardResourceProps> = ({
  slug,
  title,
  imageUrl,
  imageAlt,
}) => {
  return (
    <Link href={`/resources/${slug}`} passHref>
      <a
        css={`
          color: black;
          display: block;
        `}
      >
        <div
          css={`
            position: relative;
            z-index: 1;
            border-radius: 10px;
            overflow: hidden;
          `}
        >
          <Image
            unoptimized
            alt={imageAlt}
            src={imageUrl}
            width={260}
            height={160}
            layout="responsive"
            css={`
              overflow: hidden;
              transition: transform 0.2s ease-in-out;
              &:hover {
                transform: scale(1.05);
              }
            `}
          />
        </div>
        <div
          css={`
            font-weight: bold;
            font-size: 18px;
            line-height: 26px;
            margin: 10px 0;
          `}
        >
          {title}
        </div>
      </a>
    </Link>
  );
};

export default CardResource;
